import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-invaders',
  templateUrl: './invaders.component.html',
  styleUrls: ['./invaders.component.css']
})

export class InvadersComponent implements OnInit, OnDestroy {

  constructor() {

  }

  ngOnInit(): void {
    console.info("invaders init");
    invaders_init();
  }

  ngOnDestroy(): void {
    console.info("invaders destroy");
    window.removeEventListener("keydown", keydown);
    window.removeEventListener("keyup", keyup);
    running = false;
  }

}

class State {
  transitionMap: any;
  constructor(transitionMap) {
    this.transitionMap = transitionMap
  }
  onEnter() { }
  onExit() { }
}

class StateMachine {
  currentState: string;
  states: any;
  constructor(initialState = null, states = {}) {
    this.currentState = initialState;
    this.states = states
  }

  update(eventKey) {
    if (this.states[this.currentState].transitionMap.hasOwnProperty(eventKey)) {
      this.states[this.currentState].onExit();
      this.currentState = this.states[this.currentState].transitionMap[eventKey];
      this.states[this.currentState].onEnter();
    }
  }
}

const width = 400;
const height = 300;
const sprite = 20;

let dt;
let oldTimeStamp = 0;
let canvas;
let ctx;
let player;
let baseSpeed = 20;
let speed = 20;
let pressed = {};
let entities = [];
let lowestY = 120;
let score = 0;
let currentRound = 0;
let playerSpeed = 100;
let running = true;

let start = new State({
  "begin": "ROUND"
});
start.onEnter = () => {
  reset();
}

let round = new State({
  "death": "DEATH",
  "win": "WIN"
});
round.onEnter = () => {
  console.log("entities: ", entities);
  lowestY = 120;
  speed = baseSpeed;
  currentRound += 1;
}

let win = new State({
  "quit": "START",
  "begin": "ROUND"
});
win.onEnter = () => {
  baseSpeed += 10;
  score += currentRound * 1000;
  setTimeout(_ => {
    gameMachine.update("begin");
  }, 5000);
};
win.onExit = () => {
  entities = [];
  player = buildPlayer();
  loadEntities();
}

let death = new State({
  "begin": "START"
});
death.onEnter = () => {
  setTimeout(_ => {
    gameMachine.update("begin");
  }, 5000);
}

const gameMachine = new StateMachine("START", {
  "START": start,
  "DEATH": death,
  "ROUND": round,
  "WIN": win
});

function reset() {
  score = 0;
  currentRound = 0;
  baseSpeed = 20;
  speed = 20;
  entities = [];
  loadEntities();
}

function loadEntities() {
  for (let y = 1; y < 4; y++) {
    for (let x = 1; x < 10; x++) {
      entities.push(buildAlien(x, y));
    }
  }
  player = buildPlayer();
  entities.push(player);
}

function keydown(event) {
  pressed[event.code] = true;
  if(event.keyCode == 32 && event.target == document.body){
    event.preventDefault();
  }
}

function keyup(event) {
  delete pressed[event.code];
}

function invaders_init() {
  oldTimeStamp = 0;
  baseSpeed = 20;
  speed = 20;
  player = null;
  pressed = {};
  entities = [];
  lowestY = 120;
  score = 0;
  currentRound = 0;
  playerSpeed = 100;
  running = true;
  console.log("initializing");
  canvas = document.getElementById('canvas');
  canvas.setAttribute("width", width);
  canvas.setAttribute("height", height);
  canvas.addEventListener("click", event => {
    gameMachine.update("begin");
  });
  window.addEventListener("keydown", keydown);
  window.addEventListener("keyup", keyup);
  reset();
  ctx = canvas.getContext("2d");
  console.log("starting loop");
  window.requestAnimationFrame(loop);
}

function loop(timeStamp) {
  dt = (timeStamp - oldTimeStamp) / 1000;
  oldTimeStamp = timeStamp;

  update(dt);
  draw(ctx);

  if(running){
    window.requestAnimationFrame(loop);
  }
  
}

function update(dt) {
  if (gameMachine.currentState == "ROUND" || gameMachine.currentState == "DEATH") {
    var alienCount = 0;
    entities.forEach(e => {
      e.update(dt);
      if (e.type == "alien") {
        alienCount += 1;
      }
    });
    if (alienCount == 0) {
      gameMachine.update("win");
    }
  }
}

function draw(ctx) {
  ctx.clearRect(0, 0, 400, 300);
  ctx.beginPath();
  entities.forEach(e => {
    if (e.type == "alien") {
      ctx.strokeStyle = "green";
      ctx.beginPath();
      ctx.rect(e.x, e.y, sprite, sprite);
      ctx.stroke();
    } else if (e.type == "player") {
      ctx.strokeStyle = "red";
      ctx.beginPath();
      ctx.rect(e.x, e.y, sprite, sprite);
      ctx.stroke();
    } else if (e.type == "bullet") {
      ctx.strokeStyle = "purple";
      ctx.beginPath();
      ctx.rect(e.x - 2, e.y, 4, 10);
      ctx.stroke();
    }
  });
  ctx.font = '12px Arial';
  ctx.fillText(`Round: ${currentRound} Score: ${score}`, 260, 10);

  if (gameMachine.currentState == "START") {
    ctx.font = '50px Arial';
    ctx.fillText(`Taking Awhile?`, 40, 160);
    ctx.font = '20px Arial';
    ctx.fillText('Click to Start', 140, 190);
    ctx.font = '12px Arial';
    ctx.fillText("'A' to move left", 160, 210);
    ctx.fillText("'D' to move right", 160, 225);
    ctx.fillText("'Space' to shoot", 160, 240);

  } else if (gameMachine.currentState == "WIN") {
    ctx.font = '45px Arial';
    ctx.fillText(`Round Complete`, 25, 160);
    ctx.font = "30px Arial";
    ctx.fillText(`Score: ${score}`, 100, 200);
  } else if (gameMachine.currentState == "DEATH") {
    ctx.font = '50px Arial';
    ctx.fillText(`Game Over`, 70, 160);
    ctx.font = "30px Arial";
    ctx.fillText(`Score: ${score}`, 140, 200);
    ctx.font = "20px Arial";
    ctx.fillText(`Score: ${score}`, 160, 220);
  }

}

function buildPlayer() {
  return {
    "type": "player",
    "x": 200,
    "y": 260,
    "cooldown": 0,
    "update": function (dt) {
      if (pressed["KeyA"]) {
        this.x -= playerSpeed * dt;
      }
      if (pressed["KeyD"]) {
        this.x += playerSpeed * dt;
      }
      if (this.x < 0) {
        this.x = 0;
      }
      if (this.x > 380) {
        this.x = 380;
      }
      if (this.cooldown > 0) {
        this.cooldown -= dt;
      }
      if (pressed["Space"] && this.cooldown <= 0) {
        entities.push(buildBullet(this.x + (sprite / 2), this.y - 11, -200));
        this.cooldown = 0.5;
      }
    }
  }
}

function buildAlien(x, y) {

  let horiz = new State({ "down": "DOWN" });
  let down = new State({ "horiz": "HORIZ" });
  down.onEnter = () => { alien.move = 0; };
  var alien = {
    "type": "alien",
    "x": x * 2 * sprite,
    "y": y * 2 * sprite - 20,
    "machine": new StateMachine("HORIZ", { "DOWN": down, "HORIZ": horiz }),
    "cooldown": 0,
    "update": function (dt) {
      if (this.x < 20 || this.x > 360) {
        this.machine.update("down");
        this.x = (this.x < 20) ? 21 : 359;
      }
      if (this.move >= 20) {
        this.machine.update("horiz");
      }
      if (this.machine.currentState == "DOWN") {
        let move = speed * dt;
        this.y += move;
        this.move += move;
        if (this.y > lowestY) {
          lowestY = this.y
        }
      }
      if (this.machine.currentState == "HORIZ") {
        if (parseInt(String(this.y / sprite)) % 2 == 1) {
          this.x -= dt * speed;
        } else {
          this.x += dt * speed;
        }
      }
      if (this.cooldown > 0) {
        this.cooldown -= dt;
      }
      if (this.x > player.x && this.x < player.x + sprite && Math.abs(lowestY - this.y) < 5 && this.cooldown <= 0) {
        entities.push(buildBullet(this.x + (sprite / 2), this.y + 20, 80));
        this.cooldown = 3
      }
      if (this.y > height) {
        destroy(player);
      }
    },
    "move": 0
  };
  return alien;
}

function buildBullet(x, y, velocity) {
  return {
    "x": x,
    "y": y,
    "type": "bullet",
    "direction": velocity,
    "update": function (dt) {
      this.y += velocity * dt;
      this.timeToLive -= dt;
      if (this.timeToLive <= 0) {
        delete entities[entities.indexOf(this)]
      }
      entities.forEach(e => {
        if (e.type != "bullet" && e.x <= this.x && e.x + sprite >= this.x) {
          if (e.y <= this.y && e.y + sprite >= this.y) {
            destroy(this);
            destroy(e);
          }
        }
      })
    },
    "timeToLive": 1.5
  }
}

function destroy(entity) {
  if (entity.type == "alien") {
    speed += 5;
    score += 100;
  } else if (entity.type == "player") {
    gameMachine.update("death");
  }
  delete entities[entities.indexOf(entity)];
}
